import { useNavigate } from "react-router-dom";
import { useGetProjects } from "../../queries/project";
import { Project } from "../../types/project";

export default function Home() {
  const navigate = useNavigate();
  const { data: projects } = useGetProjects();

  const handleSelectService = (project: Project) => {

    // Cookies.set("platform", JSON.stringify(project), { sameSite: "none", secure: true });
    // Cookies.set("platform", JSON.stringify(project));
    localStorage.setItem('platform', JSON.stringify(project))

    setTimeout(() => {
      navigate("/epics");
    }, 500);
  };

  const logoGenerator = (name: string) => {
    const logoBaseUrl = "/logo";
    if (name.toLowerCase().includes("filimo") || name.includes("فیلیمو")) {
      return { name: "filimo", url: logoBaseUrl + "/filimo.png" };
    } else if (
      name.toLowerCase().includes("televika") ||
      name.includes("تلویکا")
    ) {
      return { name: "televika", url: logoBaseUrl + "/televika.png" };
    } else if (name.toLowerCase().includes("zolal") || name.includes("زلال")) {
      return { name: "zolal", url: logoBaseUrl + "/zolal.png" };
    } else if (name.toLowerCase().includes("aparat kids") || name.includes("آپارات کودک")) {
      return { name: "aparatkids", url: logoBaseUrl + "/aparatkids.png" };
    }
  };

  return (
    <div className="flex mt-10 flex-wrap">
      <h2 className="mb-8 text-lg w-full font-bold">انتخاب پروژه</h2>

      {projects?.map((project) => {
        const logo = logoGenerator(project.name);
        return (
          <div
            data-id={project.id}
            className="card card-compact w-80 bg-base-100 border-2 sm:ml-8 mb-12 cursor-pointer hover:shadow-2xl py-8"
            key={project.id}
            onClick={() => handleSelectService(project)}
          >
            <figure>
              <img src={process.env.PUBLIC_URL + logo?.url} alt={logo?.name} />
            </figure>
          </div>
        );
      })}
    </div>
  );
}
